<template>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div v-if="loading">
      <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
    </div>
    <div v-else-if="!hasCharge && !isEdit" class="mt-4 mb-4 text-xs-center">
      {{ $t('No shipping option') }}
    </div>
    <div v-else>
      <div>
        <v-layout
          align-start
          justify-start
          row
          fill-height
          wrap
          style="align-items: stretch"
        ></v-layout>
        <template v-for="(charge, cindex) in charges">
          <shipping-detail-item
            :key="'shipping_' + cindex"
            v-model="charges[cindex]"
            :isEdit="isEdit"
            :name="cindex"
            v-if="cindex != 'additionalproduct_charge'"
          ></shipping-detail-item>
        </template>
        <v-divider class="mb-3 mt-3"></v-divider>
        <shipping-detail-item
          :key="'shipping_' + 'additionalproduct_charge'"
          v-model="charges['additionalproduct_charge']"
          :isEdit="isEdit"
          :name="'additionalproduct_charge'"
        ></shipping-detail-item>
      </div>
      <div class="text-xs-center">
        <div v-if="isEdit" style="margin-top: 15px;">
          <a href="javascript:void(0);" class="btn btn-outline-gray" @click="reset">{{
            $t('cancel')
          }}</a>
          <a href="javascript:void(0);" class="btn btn-primary" @click="saveContent">{{
            $t('Save')
          }}</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import ShippingDetailItem from './ShippingDetailItem.vue'

export default {
  props: ['init', 'isEdit'],
  inject: ['$validator'],
  data: function() {
    return {
      loading: true,
      charges: []
    }
  },
  components: {
    ScaleLoader,
    ShippingDetailItem
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    hasCharge: function() {
      var vm = this
      for (const cindex in vm.charges) {
        if (vm.charges[cindex].length > 0 && vm.charges[cindex][1]) {
          return true
        } else if (vm.charges[cindex].length == 1) {
          return true
        }
      }
      return false
    }
  },
  created() {
    var vm = this
  },
  mounted: function() {
    var vm = this
    vm.loading = true
    vm.getAllShipingCharge().then(
      function() {
        vm.cached_charges = JSON.stringify(vm.charges)
        vm.loading = false
      },
      function() {
        vm.cached_charges = JSON.stringify(vm.charges)
        vm.loading = false
      }
    )
  },
  methods: {
    reset: function() {
      var vm = this
      vm.charges = JSON.parse(vm.cached_charges)
      vm.$emit('onSave')

      vm.$emit('reset')
    },
    saveContent: function() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        vm.loading = true
        vm.saveAllShipingCharge().then(
          function() {
            vm.cached_charges = JSON.stringify(vm.charges)
            vm.$emit('onSave')
            vm.loading = false
          },
          function() {
            vm.loading = true
          }
        )
      })
    },
    sendRequest: function(content, callback) {
      var vm = this
      api.updateConfig(content, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
      })
    },
    getAllShipingCharge: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getAllShipingCharge({ pageid: vm.selectedBot.pageid }, function(error, response) {
          if (error) {
            reject(error)
          }
          vm.charges = response.shippinglist
          resolve()
        })
      })
    },
    saveAllShipingCharge: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = Object.assign({}, vm.charges)
        data.pageid = vm.selectedBot.pageid
        api.saveAllShipingCharge(data, function(error, response) {
          if (error) {
            reject(error)
          }
          resolve()
        })
      })
    }
  },
  watch: {}
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/ShippingDetail.vue